module.exports = __webpack_public_path__ + "img/industrial-bridge.531ec711.jpg";